export default "__VITE_ASSET__iGp9D22E__"